/* eslint-disable @typescript-eslint/no-unused-vars */

xplenty.directive('accountsCampaignsSelector', [
  '$timeout',
  function ($timeout) {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./accounts-campaigns-selector.html'),

      replace: true,

      controller: 'accountsCampaignsSelectorController',

      scope: {
        component: '=',
        type: '@?',
      },

      link(scope, element, attrs) {},
    };
  },
]);
